import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';
import { loadStripe } from '@stripe/stripe-js';
import { composePS } from '@cd/pipe';

export default function useStripeKeyPub(dispatch) {
	return useQuery('stripeKeyPub', () =>
		composePS(
			loadStripe,
			R.prop('pub'),
			postJSONPS
		)('POST', '/stripe/key/pub').then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}
